import {
	Alert,
	Button,
	Container,
	Paper,
	PasswordInput,
	Stack,
	Text,
	TextInput,
	Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconAlertCircle } from "@tabler/icons-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
	clearError,
	clearRedirectPath,
	login,
} from "../../store/auth/authSlice";
import type { AppDispatch, RootState } from "../../store/store";

interface LoginForm {
	username: string;
	password: string;
}

function Login() {
	const dispatch = useDispatch<AppDispatch>();
	const { isLoading, error, isAuthenticated } = useSelector(
		(state: RootState) => state.auth
	);

	// Check for stored redirect path and clear it when login is successful
	useEffect(() => {
		if (isAuthenticated) {
			const redirectPath = localStorage.getItem("redirectPath");
			if (redirectPath) {
				localStorage.removeItem("redirectPath");
				dispatch(clearRedirectPath());
			}
		}
	}, [isAuthenticated, dispatch]);

	const form = useForm<LoginForm>({
		initialValues: {
			username: "",
			password: "",
		},
		validate: {
			username: (value) => (!value ? "Username is required" : null),
			password: (value) => (!value ? "Password is required" : null),
		},
	});

	const handleSubmit = (values: LoginForm) => {
		dispatch(clearError());
		dispatch(login(values));
	};

	if (isAuthenticated) {
		// Let App.tsx handle the navigation restoration
		// Just redirect to a safe default - the effect in App.tsx will handle restoring the correct route
		return (
			<Navigate
				to="/dashboard"
				replace
			/>
		);
	}

	return (
		<Container
			size={420}
			my={40}>
			<Title
				ta="center"
				style={{ fontWeight: 900 }}>
				License Management
			</Title>
			<Text
				c="dimmed"
				size="sm"
				ta="center"
				mt={5}>
				Sign in to your account
			</Text>

			<Paper
				withBorder
				shadow="md"
				p={30}
				mt={30}
				radius="md">
				<form onSubmit={form.onSubmit(handleSubmit)}>
					<Stack gap="md">
						{error && (
							<Alert
								icon={<IconAlertCircle size={16} />}
								title="Login Failed"
								color="red"
								variant="light">
								{error}
							</Alert>
						)}

						<TextInput
							label="Username"
							placeholder="Enter your username"
							required
							{...form.getInputProps("username")}
						/>

						<PasswordInput
							label="Password"
							placeholder="Enter your password"
							required
							{...form.getInputProps("password")}
						/>

						<Button
							type="submit"
							fullWidth
							loading={isLoading}
							mt="xl">
							Sign in
						</Button>
					</Stack>
				</form>

				{/* <Box
					mt="xl"
					ta="center">
					<Text
						size="sm"
						c="dimmed">
						Default admin credentials: admin / clabs@2025$!@#
					</Text>
				</Box> */}
			</Paper>
		</Container>
	);
}

export default Login;
